import { Colors } from '~/themes/colors';

interface IProps {
  color?: string;
  size?: number;
}

export const ChevronDownIcon = ({ size = 24, color = Colors.success_500 }: IProps) => {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <path
        d="M19 9L12 16L5 9"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
